import { render, staticRenderFns } from "./resource-tree.vue?vue&type=template&id=0015116a&scoped=true"
import script from "./resource-tree.vue?vue&type=script&lang=ts"
export * from "./resource-tree.vue?vue&type=script&lang=ts"
import style0 from "./resource-tree.vue?vue&type=style&index=0&id=0015116a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0015116a",
  null
  
)

export default component.exports